import React from 'react';
import moment from 'moment';
import 'moment-duration-format';
import PropTypes from 'prop-types';
import { TextMedium, TextMediumLarge } from '../../common/text';
import { convertToBST } from '../../../src/common/dates';
import { Logger } from 'common/logger';
import { Content, Col, PaddedRow } from './TooltipContent.styles';
import { DURATION_FORMAT, TIME_FORMAT } from '../../common/constants';

export const TimelineInfoTooltipContent = ({ data }) => {
    if (!data || !data.turbineData) {
        Logger.log('No data for tooltip');
        return null;
    }

    const { turbineData, beginDate, endDate, type } = data;
    const { gridKey, id } = turbineData;
    const beginTime = convertToBST(beginDate).format(TIME_FORMAT);
    const endTime = convertToBST(endDate).format(TIME_FORMAT);
    const duration = moment.duration(moment(endDate).diff(moment(beginDate))).format(...DURATION_FORMAT);

    return (
        <Content>
            <PaddedRow>
                <Col>
                    <TextMediumLarge bold>{id}</TextMediumLarge>
                </Col>
                <Col>
                    <TextMedium color="gray2">{gridKey || '-'} </TextMedium>
                </Col>
                <Col>
                    <TextMedium>&nbsp;</TextMedium>
                </Col>
                <Col>
                    <TextMedium>&nbsp;</TextMedium>
                </Col>
            </PaddedRow>
            <PaddedRow>
                <Col>
                    <TextMedium caps color="gray2">
                        Status
                    </TextMedium>
                    <TextMedium>{type}</TextMedium>
                </Col>
                <Col>
                    <TextMedium caps color="gray2">
                        Start time
                    </TextMedium>
                    <TextMedium>{beginTime}</TextMedium>
                </Col>
                <Col>
                    <TextMedium caps color="gray2">
                        End time
                    </TextMedium>
                    <TextMedium>{endTime}</TextMedium>
                </Col>
                <Col>
                    <TextMedium caps color="gray2">
                        Duration
                    </TextMedium>
                    <TextMedium>{duration}</TextMedium>
                </Col>
            </PaddedRow>
        </Content>
    );
};

TimelineInfoTooltipContent.displayName = 'TimelineInfoTooltipContent';

TimelineInfoTooltipContent.propTypes = { data: PropTypes.object };

TimelineInfoTooltipContent.defaultProps = {};
